/**
 * @generated SignedSource<<38845b3c07827329b6af5164343a799d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentFlaggingListPopoverFragment$data = {
  readonly flaggings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentFlaggingListItemFragment">;
      };
    }>;
  } | null;
  readonly " $fragmentType": "ContentFlaggingListPopoverFragment";
};
export type ContentFlaggingListPopoverFragment$key = {
  readonly " $data"?: ContentFlaggingListPopoverFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentFlaggingListPopoverFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentFlaggingListPopoverFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentFlaggingNodeConnection",
      "kind": "LinkedField",
      "name": "flaggings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentFlaggingNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentFlagging",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentFlaggingListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "ca34fcba17cdd91a42f8b02b1000698e";

export default node;
